import React from 'react';
import { Card, FlexRow, FormCell, Grid, Header2Text, NavigationItem } from '../../../ui-toolkit';
import { ITagData } from '../../../types/tags/ITagData';
import { TagsTable } from '../../../components/administration/tags/TagsTable';
import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { ClientUrlFactory } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { ButtonTW } from '../../../tailwindComponents/buttonTW/ButtonTW';
import { PermissionWrapper } from '../../../components/accessControl/PermissionWrapper';

interface ITagPageProps {
  tags: ITagData[];
}

export const TagsPage: React.FC<ITagPageProps> = ({ tags }) => {
  return (
    <Grid data-test-id={'tags-page'}>
      <Card>
        <Grid>
          <FlexRow justifyContent={'space-between'} width={100}>
            <FormCell
              hintText={
                'Tags are an easy way to add special data to an order for informational, tracking, and reporting purposes.'
              }
            >
              <Header2Text>Tags</Header2Text>
            </FormCell>
            <PermissionWrapper allowedPermissions={[ePermissions.TagEdit]}>
              <NavigationItem to={ClientUrlFactory().urlFor.administrationCreateNewTag()} text={'Create'}>
                <ButtonTW secondary type={'submit'}>
                  <FontAwesomeIcon icon={faPlus} /> Add A Tag
                </ButtonTW>
              </NavigationItem>
            </PermissionWrapper>
          </FlexRow>
          <TagsTable data={tags} />
        </Grid>
      </Card>
    </Grid>
  );
};
